<template>
		<tr>
			<th scope="row" v-html="highlight(table.currencyCode)"></th>
			<td v-html="highlight(formatDate(table.time))"></td>
			<td v-html="highlight(table.mcc?.toString())"></td>
			<td class="text-nowrap text-start">
				<i v-if="table.amount < 0" class="fas fa-arrow-down text-danger fa-lg"></i>
				<i v-else class="fas fa-arrow-up text-success fa-lg"></i>
				&#160;
				<span v-html="highlight(formatAmount(amount))"></span>
			</td>
			<td v-html="highlight(table.commissionRate?.toString())"></td>
			<td v-html="highlight(table.balance?.toString())"></td>
			<td v-html="highlight(table.cashbackAmount?.toString())"></td>
		</tr>
</template>

<script>
export default {
	props: {
		id: {
			type: String,
			required: true,
		},
		currencyCode: {
			type: String,
			required: true,
		},
		mcc: {
			type: Number,
			required: true,
		},
		amount: {
			type: Number,
			required: true,
		},
		operationAmount: {
			type: Number,
			required: true,
		},
		commissionRate: {
			type: Number,
			default: 0,
		},
		balance: {
			type: Number,
			required: true,
		},
		cashbackAmount: {
			type: Number,
			default: 0,
		},
		time: {
			type: Number,
			default: 0,
		},
		searchQuery: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			table: {
				id: this.id,
				amount: this.amount,
				balance: this.balance,
				cashbackAmount: this.cashbackAmount,
				commissionRate: this.commissionRate,
				currencyCode: this.currencyCode,
				hold: this.hold,
				mcc: this.mcc,
				operationAmount: this.operationAmount,
				receiptId: this.receiptId,
				time: this.time,
			}
		}
	},
	created() {
		// console.log(this.table);
	},
	methods: {
		formatAmount(value) {
			return (value / 100).toFixed(2);
		},
		formatDate(timestamp) {
			if (!timestamp) return '';
			return new Date(timestamp * 1000).toLocaleString('uk-UA', {
				timeZone: 'Europe/Kiev'
			});
		},
		highlight(text) {
			if (!text) return '';
			if (!this.searchQuery) return text;

			const query = this.searchQuery.toLowerCase();
			const textLower = text.toString().toLowerCase();
			const index = textLower.indexOf(query);

			if (index === -1) return text;

			const before = text.substring(0, index);
			const match = text.substring(index, index + query.length);
			const after = text.substring(index + query.length);

			return `${before}<mark class="search-highlight">${match}</mark>${after}`;
		}
	}
};
</script>

<style lang="scss">
	.table-hover > tbody > tr:hover {
		--bs-table-hover-bg: #a5f1e8;
		background-color: #a6d2e8;
	}

	mark.search-highlight {
		background-color: #ffeb3b;
		padding: 0;
	}
</style>
